import { Grid, PaperProps, Paper, Dialog, DialogTitle, Card, FormControl, InputLabel, Select, MenuItem, CircularProgress } from "@mui/material";
import { Formik, Form, FieldArray } from "formik";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { GhabzModel } from "../../../../Api/Models/GhabzModel";
import { SubscriberModel } from "../../../../Api/Models/SubscriberModel";
import MDBox from "../../../../Components/MDBox";
import MDButton from "../../../../Components/MDButton";
import MDDate from "../../../../Components/MDDate";
import MDDivider from "../../../../Components/MDDivider";
import MDInput from "../../../../Components/MDInput";
import MDTypography from "../../../../Components/MDTypography";
import { GhabzDto } from "../../../../Types/Api/DTO/GhabzDto";
import { ErrorToaast, SuccessToaast } from "../../../../utils/toast/Toast";
import * as Yup from "yup";
import { v4 as uuid } from "uuid";
import { SubscriberDto } from "../../../../Types/Api/DTO/SubscriberDto";
import { SubscribeRows } from "../../../../Types/Api/DTO/SubscribeRows";
function PaperComponent(props: PaperProps) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
export default function AddChildSubscriber({
  open,
  setClose,
  onDone,
  subscribe,
  subId,
  subscribeRows,
  subExpireDate,
  parentId,
}: // loading,
// setLoading,
{
  open: boolean;
  setClose: any;
  onDone: any;
  loading: boolean;
  setLoading: any;
  subscribe: SubscriberDto;
  subId: number;
  subscribeRows: SubscribeRows[];
  subExpireDate: string;
  parentId: number;
}) {
  const subscriberModel = new SubscriberModel();
  const [loading, setLoading] = useState(false);

  interface IinitialValues {
    Fields: {
      name: string;
      id: number;
      value: string;
    }[];
    ExpireDate: string;
    Subscriber: any;
  }
  const initialValues: IinitialValues = {
    Fields: [],
    ExpireDate: "",
    Subscriber: subscribe.subscriber,
  };
  const getData = () => {
    var field: { name: string; id: number; value: string }[] = [];
    if (subId !== 0) {
      initialValues.ExpireDate = subExpireDate;

      subscribeRows.forEach((element) => {
        field.push({ id: element.id, name: element.fieldName, value: subId === 0 ? "" : element.value });
      });
    } else {
      console.log(subscribe);

      subscribe.subscribeRows.forEach((element) => {
        field.push({ id: element.id, name: element.fieldName, value: "" });
      });
    }
    initialValues.Fields = field;
    return initialValues;
  };

  const validationSchema = Yup.object({
    Fields: Yup.array().of(
      Yup.object().shape({
        value: Yup.string().required("الزامی است"),
      })
    ),
    ExpireDate: Yup.string().required("الزامی است"),
    Subscriber: Yup.string().required("الزامی است"),
  });
  async function handleSubmit(values: IinitialValues) {
    await setLoading(true);

    var modelToSend = {
      GhabzId: subscribe.ghabzId,
      ParentId: parentId,
      ExpireDate: values.ExpireDate,
      SubscribeRows: values.Fields,
      Subscriber: values.Subscriber,
      id: subId,
    };

    if (subId !== 0) {
      await subscriberModel
        .update(subId, modelToSend)
        .then((r) => {
          SuccessToaast("با موفقیت ویرایش شد");
        })
        .catch((r) => {
          ErrorToaast("موفقیت آمیز نبود");
        });
    } else {
      await subscriberModel
        .crete(modelToSend)
        .then((r) => {
          SuccessToaast("با موفقیت اضافه شد");
        })
        .catch((r) => {
          ErrorToaast("موفقیت آمیز نبود");
        });
    }

    setLoading(false);
    await setClose();
    await onDone();
  }

  return (
    <Dialog open={open} onClose={() => setClose(true)} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title" fullWidth>
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title"></DialogTitle>
      <Card>
        <Formik enableReinitialize initialValues={getData()} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {(formikChild) => (
            <Form>
              <FieldArray
                name="Fields"
                render={(arrayHelpers) => {
                  // setarrayHelp(arrayHelpers);
                  const Fields = formikChild.values.Fields;

                  return (
                    <>
                      <MDBox pt={4} pb={3} px={2}>
                        <Grid container columnSpacing={3} rowSpacing={2}>
                          <Grid item xs={12} md={12} lg={4}>
                            <MDInput type="ghabz" name="ghabz" disabled={true} value={subscribe.ghabzAvarezName} label="کد اشتراک" fullWidth />
                          </Grid>
                          <Grid item xs={12} md={12} lg={4}>
                            <MDInput type="name" name="name" disabled={true} value={formikChild.values.Subscriber} label="کد اشتراک" fullWidth />
                          </Grid>
                          <Grid item xs={12} md={12} lg={4}>
                            <MDDate
                              name={"DateEnd"}
                              onChange={(e: any) => formikChild.setFieldValue("ExpireDate", e)}
                              error={formikChild.touched.ExpireDate && Boolean(formikChild.errors.ExpireDate)}
                              helperText={formikChild.touched.ExpireDate && formikChild.errors.ExpireDate}
                              defaultValue={formikChild.values.ExpireDate}
                              portal
                              disabled={loading}
                              label={"تاریخ اتمام"}
                            ></MDDate>
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            <MDTypography fontSize={16}>پارامتر های قبض</MDTypography>
                            <MDDivider />
                          </Grid>
                          {loading && (
                            <Grid container item xs={12} md={12} lg={12} justifyContent="center">
                              <CircularProgress />
                            </Grid>
                          )}
                          {Fields &&
                            Fields.length > 0 &&
                            Fields.map((item, index) => {
                              return (
                                <Grid item xs={12} md={12} lg={3} key={index}>
                                  <MDInput
                                    disabled={loading}
                                    // onBlur={() => handleValidate(r.FieldId)}
                                    // error={r.Error}
                                    helperText={formikChild.touched.Fields?.[index] && Boolean(formikChild.errors.Fields?.[index]) && "الزامی است "}
                                    error={formikChild.touched.Fields?.[index] && Boolean(formikChild.errors.Fields?.[index])}
                                    fullWidth
                                    label={item.name}
                                    value={item.value}
                                    onChange={(e: any) => {
                                      formikChild.setFieldValue(`Fields[${index}].value`, e.target.value);
                                    }}
                                  />
                                </Grid>
                              );
                            })}
                        </Grid>
                        <Grid container spacing={3} mt={1} justifyContent="flex-end">
                          <Grid item alignSelf={"center"}>
                            {!formikChild.isValid && (
                              <MDTypography color="error" fontSize="12px">
                                لطفا داده ها را مجددا برسی نمایید
                              </MDTypography>
                            )}
                          </Grid> 
                          <Grid item>
                            <MDButton variant="contained" color="info" type="submit" onClick={() => {}}>
                              ثبت
                            </MDButton>
                          </Grid>
                          <Grid item>
                            <MDButton variant="gradient" color="success" onClick={() => setClose()}>
                              انصراف
                            </MDButton>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </>
                  );
                }}
              />
            </Form>
          )}
        </Formik>
      </Card>
    </Dialog>
  );
}
